import { thoughtMarkdown, type DialogueSpeaker } from "@hamlak/shared";
import { MarkdownBody } from "@hamlak/ui";

/** thought{speaker, body}: 속마음. 채팅 `'…'` 속마음과 같은 렌더러(작은 말풍선, 캐릭터 왼쪽·유저 오른쪽). 본문은 줄 안 서식을 쓸 수 있다(AC0-254). */
export function ThoughtBlock({ body, speaker }: { body: string; speaker: DialogueSpeaker }) {
  return (
    <div className={speaker === "user" ? "block block--thought block--thought-user" : "block block--thought"} data-testid="block-thought">
      <MarkdownBody text={thoughtMarkdown(body)} plain mine={speaker === "user"} />
    </div>
  );
}
